<template>
  <div class="bg">
    <div class="box">
      <div class="window">
        <div class="window-left">
          <div class="window-left-title">养老机构服务信用评价平台</div>
          <img class="window-left-img" src="../assets/login.png" />
        </div>
        <div class="window-right">
          <div class="window-right-title login-title">找 回 密 码</div>
          <el-input class="login-input" v-model="username" :placeholder="usernameRule" />
          <el-input class="login-input" v-model="password" :placeholder="passwordRule" show-password />
          <el-input class="login-input" v-model="password2" :placeholder="password2Rule" show-password />
          <div class="yzm">
            <el-input class="yzm-input1" v-model="code" :placeholder="codeRule"></el-input>
            <el-button class="yzm-btn" type="primary" @click="getCode" :disabled="disabled">{{ validBtn }}</el-button>
          </div>
          <el-button class="login-btn" type="primary" @click="doResetPassword" :loading="loading">
            <span v-if="!loading">确定修改</span>
            <span v-else>修改中中...</span>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendSmsByUserName, updatePwd } from "@/api/login";

export default {
  name: 'ForgotPassword',
  data() {
    return {
      username: "",
      password: "",
      password2: "",
      code: "",
      usernameRule: "请输入用户名",
      passwordRule: "请输入新密码",
      password2Rule: "请再次输入新密码",
      codeRule: "请输入验证码",
      disabled: false,
      validBtn: '获取验证码',
      loading: false
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 获取验证码
    getCode() {
      if (!this.phone) {
        this.$message.error(this.phoneRule)
        return false
      }
      if (!this.rulerCheck('phone', this.phone)) {
        this.$message.error("联系电话不正确")
        return false
      }
      this.tackBtn();   //验证码倒数60秒
      // 发送短信验证码
      sendSmsByUserName({
        username: this.username,
        type: 0
      }).then(() => {
        this.$message.success("发送成功！")
      }).catch(() => {
        this.validBtn = '获取验证码';
      });
    },
    tackBtn() {       //验证码倒数60秒
      let time = 60;
      let timer = setInterval(() => {
        if (time === 0) {
          clearInterval(timer);
          this.validBtn = '获取验证码';
          this.disabled = false;
        } else {
          this.disabled = true;
          this.validBtn = time + '秒后重试';
          time--;
        }
      }, 1000);
    },
    doResetPassword() {
      if (!this.checkParams()) return
      this.loading = true;
      // 改密
      updatePwd({
        code: this.code,
        password: this.password,
        username: this.username,
      }).then(() => {
        this.$message.success("密码修改成功")
        this.$router.push({ path: this.redirect || "/" }).catch(()=>{});
      }).catch(() => {
        this.loading = false;
      });
    },
    // 通过校验返回 true,否则返回 false
    checkParams() {
      if (!this.username) {
        this.$message.error(this.usernameRule)
        return false
      }
      if (!this.password) {
        this.$message.error(this.passwordRule)
        return false
      }
      if (!this.password2) {
        this.$message.error(this.password2Rule)
        return false
      }
      if (this.password !== this.password2) {
        this.$message.error("两次输入的密码不一致")
        return false
      }
      if (!this.code) {
        this.$message.error(this.codeRule)
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>

.login-title {
  margin: 20px auto 60px;
}
a {
  color: rgba(255, 255, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue